import { recordEventCustomOnly } from 'utilities/uTagging';
export const doTagEmailFieldFocus = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textbox',
        component: 'form',
        element: 'email',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'emailTextBox',
    });
};

export const doTagValidateEmail = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'button',
        component: 'form',
        element: 'validateEmail',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickButton',
        eventLabel: 'validateEmailButton',
    });
};

export const doTagModifyEmail = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'OTP/email',
        element: 'modifyEmail',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickLink',
        eventLabel: 'modifyEmail',
    });
};

export const doTagShowOTP = () => {
    recordEventCustomOnly({
        action: 'start',
        format: 'otpAuthentication',
        component: 'OTP/email',
        element: 'backend',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'otpAuthenticationEmail',
        eventLabel: 'start',
    });
};

export const doTagOTPField = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textBox',
        component: 'OTP/email',
        element: 'enterCode',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'enterCodeTextBox',
    });
};
export const doTagSuccessfulOTP = () => {
    recordEventCustomOnly({
        action: 'success',
        format: 'otpAuthentication',
        component: 'OTP/email',
        element: 'backend',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'otpAuthenticationEmail',
        eventLabel: 'success',
    });
};

export const doTagOTPResend = () => {
    recordEventCustomOnly({
        action: 'click',
        format: 'link',
        component: 'OTP/email',
        element: 'requestNewCode',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickLink',
        eventLabel: 'newCodeLink',
    });
};
export const doTagIncorrectOTP = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textBox',
        component: 'OTP',
        element: 'errorOTPField',
        errorCategory: 'errorIncorrectCode',
        errorDescription: 'otpEmailValidation-incorrectCode',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    });
};

export const doTagSuccessfulSnackBar = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'snackbar',
        component: 'snackbar/success/newEmailSent',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'successSnackbarNewEmailSent',
        eventLabel: 'view',
    });
};

export const doTagErrorSnackBar = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'snackbar',
        component: 'snackbar/error/newEmailNotSent',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'errorSnackbarNewEmailNotSent',
        eventLabel: 'view',
    });
};

export const doTagOTPExceededAttemps = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'message',
        component: 'message/error/exceededAttemps',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'errorMessageExceededAttemps',
        eventLabel: 'view',
    });
};

export const doTagMaxRetrySendEmailOTPLimit = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'message',
        component: 'message/warning/maxRequestsEmail',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'warningMessageMaxRequestsEmail',
        eventLabel: 'view',
    });
};

export const doTagExpiredOTP = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'message',
        component: 'message/error/codeExpired',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'errorMessageCodeExpired',
        eventLabel: 'view',
    });
};

export const doTagIncorrectOTPLimit = () => {
    recordEventCustomOnly({
        action: 'open',
        format: 'message',
        component: 'message/error/incorrectCode3Times',
        element: 'full',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'errorMessageIncorrectCode3Times',
        eventLabel: 'view',
    });
};
export const doTagSameEmailError = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textBox',
        component: 'form',
        element: 'errorEmailField',
        errorCategory: 'errorSameEmailCode',
        errorDescription: 'emailValidation-introduceAnotherEmail',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    });
};

export const doTagOTPFieldRequired = () => {
    recordEventCustomOnly({
        action: 'type',
        format: 'textBox',
        component: 'OTP',
        element: 'errorOTPField',
        errorCategory: 'errorRequiredField',
        errorDescription: 'validation-fieldRequired',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'clickTextBox',
        eventLabel: 'textBox - error',
    });
};

export const doTagIsValidAndGoNext = () => {
    recordEventCustomOnly({
        event_name: 'event_success',
        eventCategory: 'onboarding/step3/validateEmail',
        eventAction: 'success',
        eventLabel: 'backend',
        action: 'success',
        format: 'steps',
        component: 'funnel',
        element: 'validateEmail',
    });
};
